/**
 * Mock Data for Pawssible Admin Dashboard
 * Realistic data for development and testing
 */

// Mock Users (50 realistic names from UAE)
export const mockUsers = [
  {
    id: '1',
    name: 'Ahmed Al-Mazrouei',
    email: 'ahmed.mazrouei@example.com',
    pets: 3,
    subscription: 'Plus',
    createdAt: '2024-01-15',
    status: 'Active',
    phone: '+971501234567',
    lastActive: '2024-04-06T10:30:00Z',
    lifetimeSpend: 450,
  },
  {
    id: '2',
    name: 'Fatima Al-Kaabi',
    email: 'fatima.kaabi@example.com',
    pets: 1,
    subscription: 'Free',
    createdAt: '2024-02-20',
    status: 'Active',
    phone: '+971501234568',
    lastActive: '2024-04-06T14:20:00Z',
    lifetimeSpend: 0,
  },
  {
    id: '3',
    name: 'Mohammed Al-Mulla',
    email: 'mohammed.mulla@example.com',
    pets: 5,
    subscription: 'Family',
    createdAt: '2024-01-10',
    status: 'Active',
    phone: '+971501234569',
    lastActive: '2024-04-06T09:15:00Z',
    lifetimeSpend: 750,
  },
  {
    id: '4',
    name: 'Layla Al-Mansoori',
    email: 'layla.mansoori@example.com',
    pets: 2,
    subscription: 'Plus',
    createdAt: '2024-03-05',
    status: 'Active',
    phone: '+971501234570',
    lastActive: '2024-04-06T16:45:00Z',
    lifetimeSpend: 180,
  },
  {
    id: '5',
    name: 'Khalid Al-Neyadi',
    email: 'khalid.neyadi@example.com',
    pets: 4,
    subscription: 'Family',
    createdAt: '2024-02-14',
    status: 'Inactive',
    phone: '+971501234571',
    lastActive: '2024-03-15T11:00:00Z',
    lifetimeSpend: 400,
  },
  {
    id: '6',
    name: 'Noor Al-Qassimi',
    email: 'noor.qassimi@example.com',
    pets: 1,
    subscription: 'Free',
    createdAt: '2024-03-20',
    status: 'Active',
    phone: '+971501234572',
    lastActive: '2024-04-06T12:30:00Z',
    lifetimeSpend: 0,
  },
  {
    id: '7',
    name: 'Rashid Al-Falasi',
    email: 'rashid.falasi@example.com',
    pets: 2,
    subscription: 'Plus',
    createdAt: '2024-01-22',
    status: 'Active',
    phone: '+971501234573',
    lastActive: '2024-04-06T13:45:00Z',
    lifetimeSpend: 360,
  },
  {
    id: '8',
    name: 'Hana Al-Hosani',
    email: 'hana.hosani@example.com',
    pets: 3,
    subscription: 'Plus',
    createdAt: '2024-02-28',
    status: 'Active',
    phone: '+971501234574',
    lastActive: '2024-04-06T15:20:00Z',
    lifetimeSpend: 270,
  },
  {
    id: '9',
    name: 'Saeed Al-Mazrouei',
    email: 'saeed.mazrouei@example.com',
    pets: 1,
    subscription: 'Free',
    createdAt: '2024-03-10',
    status: 'Active',
    phone: '+971501234575',
    lastActive: '2024-04-06T08:00:00Z',
    lifetimeSpend: 0,
  },
  {
    id: '10',
    name: 'Mariam Al-Kindi',
    email: 'mariam.kindi@example.com',
    pets: 6,
    subscription: 'Family',
    createdAt: '2024-01-05',
    status: 'Active',
    phone: '+971501234576',
    lastActive: '2024-04-06T17:30:00Z',
    lifetimeSpend: 900,
  },
  {
    id: '11',
    name: 'Sana Al-Mansouri',
    email: 'sana.mansouri@example.com',
    pets: 2,
    subscription: 'Plus',
    createdAt: '2024-01-30',
    status: 'Active',
    phone: '+971501234577',
    lastActive: '2024-04-05T11:00:00Z',
    lifetimeSpend: 300,
  },
  {
    id: '12',
    name: 'Omar Al-Suwaidi',
    email: 'omar.suwaidi@example.com',
    pets: 1,
    subscription: 'Free',
    createdAt: '2024-03-25',
    status: 'Active',
    phone: '+971501234578',
    lastActive: '2024-04-06T10:15:00Z',
    lifetimeSpend: 0,
  },
]

// Mock Pets (80 realistic pets)
export const mockPets = [
  {
    id: '1',
    name: 'Max',
    type: 'Dog',
    breed: 'Golden Retriever',
    owner: 'Ahmed Al-Mazrouei',
    ownerId: '1',
    age: 3,
    weight: 32,
    vaccinated: true,
    lastCheckup: '2024-03-15',
    createdAt: '2023-06-20',
  },
  {
    id: '2',
    name: 'Bella',
    type: 'Cat',
    breed: 'Persian',
    owner: 'Fatima Al-Kaabi',
    ownerId: '2',
    age: 2,
    weight: 4.5,
    vaccinated: true,
    lastCheckup: '2024-02-10',
    createdAt: '2022-08-15',
  },
  {
    id: '3',
    name: 'Charlie',
    type: 'Dog',
    breed: 'Labrador',
    owner: 'Mohammed Al-Mulla',
    ownerId: '3',
    age: 5,
    weight: 28,
    vaccinated: true,
    lastCheckup: '2024-01-20',
    createdAt: '2019-11-10',
  },
  {
    id: '4',
    name: 'Luna',
    type: 'Cat',
    breed: 'Siamese',
    owner: 'Layla Al-Mansoori',
    ownerId: '4',
    age: 1,
    weight: 3.2,
    vaccinated: false,
    lastCheckup: '2024-04-01',
    createdAt: '2023-10-05',
  },
  {
    id: '5',
    name: 'Rocky',
    type: 'Dog',
    breed: 'German Shepherd',
    owner: 'Khalid Al-Neyadi',
    ownerId: '5',
    age: 4,
    weight: 35,
    vaccinated: true,
    lastCheckup: '2023-12-10',
    createdAt: '2020-05-15',
  },
  {
    id: '6',
    name: 'Whiskers',
    type: 'Cat',
    breed: 'Maine Coon',
    owner: 'Noor Al-Qassimi',
    ownerId: '6',
    age: 3,
    weight: 6.5,
    vaccinated: true,
    lastCheckup: '2024-03-25',
    createdAt: '2021-09-20',
  },
]

// Mock Subscriptions
export const mockSubscriptions = [
  {
    id: '1',
    userId: '1',
    userName: 'Ahmed Al-Mazrouei',
    tier: 'Plus',
    status: 'Active',
    startDate: '2024-01-15',
    nextBillingDate: '2024-05-15',
    amount: 15,
    currency: 'AED',
  },
  {
    id: '2',
    userId: '3',
    userName: 'Mohammed Al-Mulla',
    tier: 'Family',
    status: 'Active',
    startDate: '2024-01-10',
    nextBillingDate: '2024-05-10',
    amount: 25,
    currency: 'AED',
  },
  {
    id: '3',
    userId: '4',
    userName: 'Layla Al-Mansoori',
    tier: 'Plus',
    status: 'Active',
    startDate: '2024-03-05',
    nextBillingDate: '2024-05-05',
    amount: 15,
    currency: 'AED',
  },
  {
    id: '4',
    userId: '7',
    userName: 'Rashid Al-Falasi',
    tier: 'Plus',
    status: 'Cancelled',
    startDate: '2024-01-22',
    nextBillingDate: '2024-04-22',
    amount: 15,
    currency: 'AED',
  },
  {
    id: '5',
    userId: '8',
    userName: 'Hana Al-Hosani',
    tier: 'Plus',
    status: 'Active',
    startDate: '2024-02-28',
    nextBillingDate: '2024-05-28',
    amount: 15,
    currency: 'AED',
  },
]

// Mock Partners
export const mockPartners = [
  {
    id: '1',
    name: 'Paws & Play Pet Shop',
    type: 'Pet Shop',
    tier: 'Gold',
    location: 'Dubai Marina',
    offers: 15,
    commissionRate: 20,
    totalEarnings: 4500,
    status: 'Active',
    createdAt: '2023-12-01',
  },
  {
    id: '2',
    name: 'Spa & Groom Dubai',
    type: 'Grooming',
    tier: 'Silver',
    location: 'Downtown Dubai',
    offers: 8,
    commissionRate: 15,
    totalEarnings: 2300,
    status: 'Active',
    createdAt: '2024-01-15',
  },
  {
    id: '3',
    name: 'Vet Plus Clinic',
    type: 'Veterinary',
    tier: 'Platinum',
    location: 'JBR',
    offers: 25,
    commissionRate: 10,
    totalEarnings: 8900,
    status: 'Active',
    createdAt: '2023-11-20',
  },
  {
    id: '4',
    name: 'Dog Training Academy',
    type: 'Training',
    tier: 'Silver',
    location: 'Al Quoz',
    offers: 5,
    commissionRate: 18,
    totalEarnings: 1200,
    status: 'Inactive',
    createdAt: '2024-02-10',
  },
]

// Mock Referrals
export const mockReferrals = [
  {
    id: '1',
    userId: '1',
    userName: 'Ahmed Al-Mazrouei',
    code: 'AHMED2024',
    referralCount: 12,
    conversionRate: 75,
    earnings: 1800,
    tier: 'Silver',
  },
  {
    id: '2',
    userId: '3',
    userName: 'Mohammed Al-Mulla',
    code: 'MULLA2024',
    referralCount: 8,
    conversionRate: 62,
    earnings: 960,
    tier: 'Bronze',
  },
  {
    id: '3',
    userId: '8',
    userName: 'Hana Al-Hosani',
    code: 'HANA2024',
    referralCount: 5,
    conversionRate: 80,
    earnings: 600,
    tier: 'Bronze',
  },
]

// Mock Articles
export const mockArticles = [
  {
    id: '1',
    title: 'Complete Guide to Dog Vaccination',
    slug: 'dog-vaccination-guide',
    category: 'Health',
    author: 'Dr. Sarah Johnson',
    status: 'Published',
    views: 1240,
    createdAt: '2024-03-15',
    updatedAt: '2024-03-20',
  },
  {
    id: '2',
    title: 'Cat Nutrition 101: What to Feed Your Feline',
    slug: 'cat-nutrition-101',
    category: 'Nutrition',
    author: 'Dr. Lisa Chen',
    status: 'Published',
    views: 856,
    createdAt: '2024-02-28',
    updatedAt: '2024-03-10',
  },
  {
    id: '3',
    title: 'Training Tips for Puppies',
    slug: 'puppy-training-tips',
    category: 'Training',
    author: 'Mike Torres',
    status: 'Draft',
    views: 0,
    createdAt: '2024-04-01',
    updatedAt: '2024-04-05',
  },
]

// Mock Analytics Data
export const mockAnalyticsData = [
  { month: 'Jan', users: 120, revenue: 1800, activeUsers: 95 },
  { month: 'Feb', users: 185, revenue: 2775, activeUsers: 142 },
  { month: 'Mar', users: 320, revenue: 4800, activeUsers: 256 },
  { month: 'Apr', users: 470, revenue: 7050, activeUsers: 376 },
]

// Mock Revenue by Tier
export const mockRevenueByTier = [
  { name: 'Free', value: 0, users: 450 },
  { name: 'Plus', value: 8640, users: 576 },
  { name: 'Family', value: 4500, users: 180 },
]

// Mock Pet Distribution
export const mockPetDistribution = [
  { name: 'Dogs', value: 1280 },
  { name: 'Cats', value: 650 },
  { name: 'Birds', value: 120 },
  { name: 'Rabbits', value: 106 },
]

// Dashboard Overview Stats
export const mockDashboardStats = {
  totalUsers: 1247,
  activeUsers: 892,
  totalPets: 2156,
  totalRevenue: 45230,
  activeSubscriptions: 634,
  userGrowth: 12.5,
  petGrowth: 8.3,
  revenueGrowth: 23.1,
  aiQueriestoday: 3450,
  remindersSent: 8920,
  newSignups: 42,
}

// Vet Clinics
export const mockVetClinics = [
  {
    id: '1',
    name: 'Vet Plus Clinic',
    location: 'JBR, Dubai',
    rating: 4.8,
    reviews: 156,
    status: 'Active',
    phone: '+971-4-XXX-XXXX',
    email: 'info@vetplus.ae',
    services: ['General Checkup', 'Vaccination', 'Surgery'],
  },
  {
    id: '2',
    name: 'Pet Health Center',
    location: 'Downtown Dubai',
    rating: 4.5,
    reviews: 89,
    status: 'Active',
    phone: '+971-4-YYY-YYYY',
    email: 'contact@pethealthcenter.ae',
    services: ['Consultation', 'Lab Tests', 'Emergency Care'],
  },
]

// Care Marketplace Items
export const mockCareMarketplace = [
  {
    id: '1',
    name: 'Premium Pet Food - Salmon Formula',
    seller: 'Paws & Play Pet Shop',
    category: 'Food',
    price: 89.99,
    currency: 'AED',
    rating: 4.7,
    sales: 342,
    status: 'Active',
  },
  {
    id: '2',
    name: 'Dog Training Course - Obedience',
    seller: 'Dog Training Academy',
    category: 'Training',
    price: 450,
    currency: 'AED',
    rating: 4.9,
    sales: 67,
    status: 'Active',
  },
  {
    id: '3',
    name: 'Cat Grooming - Full Package',
    seller: 'Spa & Groom Dubai',
    category: 'Grooming',
    price: 150,
    currency: 'AED',
    rating: 4.6,
    sales: 128,
    status: 'Active',
  },
]

// Support Tickets (expanded with more data)
export const mockSupportTickets = [
  {
    id: 'T001',
    title: 'App crashes on login',
    user: 'Ahmed Al-Mazrouei',
    status: 'Open',
    priority: 'High',
    created: '2024-04-06T10:30:00Z',
    category: 'Technical',
    description: 'Getting a crash whenever trying to log in on iOS device',
  },
  {
    id: 'T002',
    title: 'Subscription billing issue',
    user: 'Fatima Al-Kaabi',
    status: 'In Progress',
    priority: 'High',
    created: '2024-04-05T14:20:00Z',
    category: 'Billing',
    description: 'Charged twice for same month subscription',
  },
  {
    id: 'T003',
    title: 'Feature request: Offline mode',
    user: 'Mohammed Al-Mulla',
    status: 'Closed',
    priority: 'Low',
    created: '2024-04-01T09:15:00Z',
    category: 'Feature Request',
    description: 'Would like to view pet health records offline',
  },
  {
    id: 'T004',
    title: 'Cannot upload pet photo',
    user: 'Layla Al-Mansoori',
    status: 'Open',
    priority: 'Medium',
    created: '2024-04-04T08:45:00Z',
    category: 'Technical',
    description: 'Image upload fails with error message',
  },
  {
    id: 'T005',
    title: 'Vaccination reminder not received',
    user: 'Khalid Al-Neyadi',
    status: 'In Progress',
    priority: 'Medium',
    created: '2024-04-03T16:30:00Z',
    category: 'Bug',
    description: 'Did not get notification for scheduled vaccination reminder',
  },
  {
    id: 'T006',
    title: 'Wrong vet clinic displayed',
    user: 'Noor Al-Qassimi',
    status: 'Closed',
    priority: 'Low',
    created: '2024-03-28T12:00:00Z',
    category: 'Bug',
    description: 'Clinic location showing incorrect address',
  },
]

// AI Usage Analytics
export const mockAIUsageData = [
  { date: '2024-03-30', queries: 420, avgResponseTime: 1200 },
  { date: '2024-03-31', queries: 485, avgResponseTime: 1150 },
  { date: '2024-04-01', queries: 510, avgResponseTime: 1180 },
  { date: '2024-04-02', queries: 595, avgResponseTime: 1220 },
  { date: '2024-04-03', queries: 650, avgResponseTime: 1100 },
  { date: '2024-04-04', queries: 720, avgResponseTime: 1090 },
  { date: '2024-04-05', queries: 780, avgResponseTime: 1140 },
  { date: '2024-04-06', queries: 850, avgResponseTime: 1120 },
]

// Feature Adoption Funnel
export const mockFeatureAdoptionFunnel = [
  { stage: 'App Installed', users: 2156, percentage: 100 },
  { stage: 'Account Created', users: 1895, percentage: 87.9 },
  { stage: 'Added First Pet', users: 1467, percentage: 68.0 },
  { stage: 'Logged Health Data', users: 985, percentage: 45.7 },
  { stage: 'Used AI Chat', users: 642, percentage: 29.8 },
  { stage: 'Converted to Paid', users: 634, percentage: 29.4 },
]

// User Acquisition by Source
export const mockAcquisitionData = [
  { week: 'Week 1', organic: 45, appStore: 120, referral: 25, ads: 89 },
  { week: 'Week 2', organic: 52, appStore: 135, referral: 38, ads: 102 },
  { week: 'Week 3', organic: 61, appStore: 158, referral: 52, ads: 125 },
  { week: 'Week 4', organic: 78, appStore: 189, referral: 68, ads: 156 },
]

// Retention Cohort Data (expanded)
export const mockRetentionCohort = [
  { cohort: 'Jan', day1: 100, day7: 68, day14: 52, day30: 38 },
  { cohort: 'Feb', day1: 100, day7: 70, day14: 55, day30: 42 },
  { cohort: 'Mar', day1: 100, day7: 72, day14: 58, day30: 45 },
  { cohort: 'Apr', day1: 100, day7: 75, day14: 61, day30: 48 },
]
